/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Typography, Table, InputNumber, Form } from 'antd';
const { Text } = Typography;

const renderTime = (_, row) => {
  const { startHour, endHour } = row;
  const hours = endHour - startHour;
  return <Text>{hours} hours</Text>;
};

const EditableContext = React.createContext();

class EditableCell extends React.Component {
  getInput = () => {
    return <InputNumber min={0} max={23} />;
  };

  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      record,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: `Please Input ${title}!`
                }
              ],
              initialValue: record[dataIndex]
            })(this.getInput())}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return (
      <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
    );
  }
}

function HKServiceTable({
  availabiliies,
  editable = true,
  saveRowResolver,
  form: propForm,
  rowKey = 'availabilityID'
}) {
  const components = {
    body: {
      cell: EditableCell
    }
  };

  const [editingKey, setEditingKey] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSaveRow = form => {
    form.validateFields(async (error, row) => {
      if (error) {
        return;
      }

      const { startHour, endHour } = row;

      if (endHour < startHour) {
        return;
      }

      setIsSubmitting(true);

      if (saveRowResolver) {
        await saveRowResolver(row, editingKey);
      }

      setEditingKey('');
      setIsSubmitting(false);
    });
  };

  const renderOperation = (text, record) => {
    const isEditing = record[rowKey] === editingKey;
    return isEditing ? (
      <span>
        <EditableContext.Consumer>
          {form => (
            <a
              disabled={isSubmitting}
              onClick={() => handleSaveRow(form)}
              style={{ marginRight: 8 }}
            >
              Save
            </a>
          )}
        </EditableContext.Consumer>
        <a onClick={() => setEditingKey('')}>Cancel</a>
      </span>
    ) : (
      <a
        disabled={editingKey !== '' || isSubmitting}
        onClick={() => setEditingKey(record[rowKey])}
      >
        Edit
      </a>
    );
  };

  const availabilityColums = [
    {
      title: 'Day of Week',
      dataIndex: 'day',
      key: 'day'
    },
    {
      title: 'Start Time',
      dataIndex: 'startHour',
      key: 'startHour',
      editable
    },
    {
      title: 'End Time',
      dataIndex: 'endHour',
      key: 'endHour',
      editable
    },
    {
      title: 'Total Hours',
      dataIndex: 'time',
      key: 'time',
      render: renderTime
    }
  ].concat([
    editable
      ? {
          title: '',
          dataIndex: 'operation',
          key: 'operation',
          render: renderOperation
        }
      : []
  ]);

  const columns = availabilityColums.map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: record[rowKey] === editingKey
      })
    };
  });

  return (
    <EditableContext.Provider value={propForm}>
      <Table
        components={components}
        dataSource={availabiliies}
        columns={columns}
        pagination={false}
      />
    </EditableContext.Provider>
  );
}

const EditableFormTable = Form.create()(HKServiceTable);

export default EditableFormTable;
